export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/7606267782c842e5ba8747fe77d08730/6531d0ba59902eecd1934284b997fcb6.jpeg"
          alt="Steel Importações"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/85 via-gray-900/80 to-gray-900/90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-32">
        <div className="text-center mb-16">
          <div className="inline-block mb-6 px-5 py-2 bg-white/10 backdrop-blur-xl border border-white/20 rounded-full">
            <span className="text-indigo-400 font-semibold text-sm">✨ Sua importação com segurança e transparência</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Bem-vindo à<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-indigo-600">
              Steel Importações
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
            Faça parte da nossa comunidade de importadores inteligentes! Estamos aqui para tornar seu sonho de importar dos EUA uma realidade acessível e sem complicações.
          </p>

          <div className="flex justify-center items-center mb-16">
            <button
              onClick={() => scrollToSection('about')}
              className="px-10 py-4 bg-white/10 backdrop-blur-xl border border-white/20 text-white text-lg font-semibold rounded-full hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              Conheça Nossa História
            </button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-16">
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
              <div className="text-4xl font-bold text-indigo-400 mb-2">+1000</div>
              <div className="text-gray-300 font-medium">Clientes Satisfeitos</div>
            </div>
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
              <div className="text-4xl font-bold text-indigo-400 mb-2">+1500</div>
              <div className="text-gray-300 font-medium">Produtos Importados</div>
            </div>
            <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all">
              <div className="text-4xl font-bold text-indigo-400 mb-2">100%</div>
              <div className="text-gray-300 font-medium">Transparência Total</div>
            </div>
          </div>
        </div>

        {/* Nossa História - Apenas Desktop */}
        <div className="hidden md:block">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Nossa História
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed">
              Mais do que uma empresa, somos uma comunidade que acredita que importar não precisa ser complicado ou inacessível.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-3xl p-8 md:p-10 shadow-2xl">
            <p className="text-lg text-gray-200 leading-relaxed mb-6">
              A <strong className="text-indigo-400">Steel Importações</strong> nasceu do desejo de ajudar pessoas como você a realizarem o sonho de ter acesso a produtos Apple com valores mais justos e uma maior personalização, vindo direto dos Estados Unidos, sem burocracia e com total transparência.
            </p>
            
            <p className="text-lg text-gray-200 leading-relaxed mb-6">
              Sabemos que importar pode parecer intimidador no começo, e é exatamente por isso que estamos aqui: para te acompanhar em cada passo dessa jornada. Nossa equipe trabalha todos os dias com um único objetivo: <strong className="text-indigo-400">fazer você se sentir seguro e bem cuidado</strong>.
            </p>

            <p className="text-lg text-gray-200 leading-relaxed">
              Quando você escolhe a Steel, você não está apenas contratando um serviço - você está entrando para uma comunidade de pessoas que priorizam qualidade com preço justo e, o principal, <strong className="text-indigo-400">SEGURANÇA!</strong> 💙
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
